import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { useLocation, useNavigate } from "react-router";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  TooltipComponent,
  Col,
  Row,
} from "../../components/Component";
import { BASE_URL_IMG, RUPEES_SYMBOL } from "../../assets/constants";
import { Spinner, Card, CardBody, Badge, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from "reactstrap";
import useLogout from "../../hooks/useLogout";
import { toast } from "react-toastify";
import { cancelOrderApi, confirmOrderAPI, getOrdersDetailsAPI, listPharmacyTelecaller } from "../../api/pahrmacy";
import moment from "moment";
import CancelOrderModal from "../../MyComp/UI/modals/CancelOrderModal";
import { useForm } from "react-hook-form";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import { confirmOrderSplit } from "../../api/pahrmacy";

const PharmacyTelecallerOrderDetailsAndPharmac = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const [showModal, setShowModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);
  const [data, setData] = useState(null);

  const [pharmacyData, setPharmacyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pharmacyLoading, setPharmacyLoading] = useState(false);
  const [orders, setOrders] = useState([]);

  // New state for medicine selection
  const [medicineItems, setMedicineItems] = useState([]);
  const [selectedMedicines, setSelectedMedicines] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const { setValue } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
      image_preview: null,
    },
  });

  const handleImageOpenPreview = (imageUrl) => {
    setValue("image_preview", imageUrl);
  };

  // Initialize medicine items from order data
  useEffect(() => {
    if (data?.items) {
      const items = data.items.map((item, index) => ({
        id: index,
        medicineId: item.medicineId,
        name: item.product_name,
        quantity: item.quantity,
        price: item.unit_price,
        total: item.total,
        selected: false
      }));
      setMedicineItems(items);
      setSelectedMedicines([]);
      setSelectAll(false);
    }
  }, [data]);

  // Handle select all functionality
  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      const allItemIds = medicineItems.map(item => item.id);
      setSelectedMedicines(allItemIds);
      setMedicineItems(medicineItems.map(item => ({ ...item, selected: true })));
    } else {
      setSelectedMedicines([]);
      setMedicineItems(medicineItems.map(item => ({ ...item, selected: false })));
    }
  };

  // Handle individual checkbox selection
  const handleMedicineSelect = (itemId) => {
    let updatedSelected = [...selectedMedicines];
    let updatedItems = medicineItems.map(item => {
      if (item.id === itemId) {
        const newSelected = !item.selected;
        if (newSelected) {
          updatedSelected.push(item.id);
        } else {
          updatedSelected = updatedSelected.filter(id => id !== item.id);
        }
        return { ...item, selected: newSelected };
      }
      return item;
    });

    setSelectedMedicines(updatedSelected);
    setMedicineItems(updatedItems);
    setSelectAll(updatedSelected.length === medicineItems.length);
  };

  const handleConfirmClick = async () => {
    if (selectedMedicines.length === 0) {
      toast.warning("Please select at least one medicine to confirm");
      return;
    }

    try {
      // Get selected medicines
      const selectedItems = medicineItems.filter(item =>
        selectedMedicines.includes(item.id)
      );

      // Create allocations object
      const allocation = {
        [selectedRow.pharmacyId]: selectedItems.map(item => ({
          medicineId: item.medicineId
        }))
      };


      // Final payload
      const payload = {
        orderId: location.state.orderId,
        allocation
      };
       console.log(payload,"payload");
       
      // API Call
      const response = await confirmOrderSplit(payload);

      if (response?.data?.message) {
        toast.success(response.data.message);
      } else {
        toast.success("Order confirmed successfully!");
      }

      setViewModal(false);

      navigate("/telecaller-pharmacy", {
        state: {
          medicine_name: selectedRow?.medicine_name,
          strength: selectedRow?.strength,
          id: selectedRow?.id,
          mode: "Add",
          fromRequest: true,
          confirmedMedicines: selectedItems
        },
      });

    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("Failed to confirm order. Please try again.");
      }

      console.error("Error confirming order:", error);
    }
  };

  //  const handleConfirmClick = async () => {
  //   if (selectedMedicines.length === 0) {
  //     toast.warning("Please select at least one medicine to confirm");
  //     return;
  //   }

  //   try {
  //     // Get selected medicine details
  //     const selectedItems = medicineItems.filter(item => selectedMedicines.includes(item.id));

  //     // Call the API with selected medicines
  //     const response = await confirmOrderAPI({
  //       pharmacyId: selectedRow.pharmacyId,
  //       orderId: location.state.orderId,
  //       selectedMedicines: selectedItems.map(item => ({
  //         medicineName: item.name,
  //         quantity: item.quantity,
  //         price: item.price
  //       }))
  //     });

  //     if (response?.data?.message) {
  //       toast.success(response.data.message);
  //     } else {
  //       toast.success("Order confirmed successfully!");
  //     }

  //     setViewModal(false);

  //     // Navigate after successful API call
  //     navigate("/telecaller-pharmacy", {
  //       state: {
  //         medicine_name: selectedRow?.medicine_name,
  //         strength: selectedRow?.strength,
  //         id: selectedRow?.id,
  //         mode: "Add",
  //         fromRequest: true,
  //         confirmedMedicines: selectedItems
  //       },
  //     });

  //   } catch (error) {
  //     if (error?.response?.data?.message) {
  //       toast.error(error.response.data.message);
  //     } else if (error.message) {
  //       toast.error(error.message);
  //     } else {
  //       toast.error("Failed to confirm order. Please try again.");
  //     }

  //     console.error("Error confirming order:", error);
  //   }
  // };

  const handleGoDashboard = (row) => {
    setSelectedRow(row);
    // Reset selections when opening modal for new pharmacy
    setSelectedMedicines([]);
    setSelectAll(false);
    setMedicineItems(medicineItems.map(item => ({ ...item, selected: false })));
    setViewModal(true);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "delivered":
      case "paid":
        return "success";
      case "processing":
      case "shipped":
      case "out_for_delivery":
        return "warning";
      case "cancelled":
        return "danger";
      default:
        return "primary";
    }
  };

  useEffect(() => {
    if (location?.state?.orderId) {
      getPharmacyList();
    }
  }, [location?.state?.orderId]);

  useEffect(() => {
    if (location?.state) {
      orderDetails();
    }
  }, [location?.state]);

  const getPharmacyList = () => {
    setPharmacyLoading(true);
    listPharmacyTelecaller({ orderId: location.state.orderId })
      .then((res) => {
        if (res?.data?.status === "expired") {
          toast.error(res?.data?.message);
          logout();
        } else if (res?.data?.status === true) {
          setPharmacyData(res?.data?.data?.nearbyPharmacies || []);
        } else if (res.data.status === false) {
          setPharmacyData([]);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setPharmacyData([]);
      })
      .finally(() => {
        setPharmacyLoading(false);
      });
  };

  const orderDetails = () => {
    setIsLoading(true);
    getOrdersDetailsAPI(location?.state)
      .then((res) => {
        if (res?.data?.status === "expired") {
          toast.error(res?.data?.message);
          logout();
          return;
        }
        if (res?.data?.status === true) {
          const { order, orderItems } = res?.data?.data;
          const ph = order?.pharmacy;
          setOrders(order);
          setData({
            id: order?.id,
            pharmacy_name: ph?.store_name,
            pharmacy_gst: ph?.gst_number,
            pharmacy_contact: ph?.mobile,
            order_no: order?.orderNum,
            date: order?.createdAt ? moment(order.createdAt).format("DD MMM YYYY, hh:mm A") : "",
            order_status: order?.status,
            subtotal: order?.orderAmount || 0,
            tax: 0,
            discount: order?.discountAmount || 0,
            shipping_cost: 0,
            total_amount: order?.totalAmount || 0,
            remark: order?.remark || "",
            address: {
              full_name: order?.address?.name || "",
              mobile: order?.address?.mobile || "",
              address: order?.address?.addressLine1 || "",
              city: order?.address?.city || "",
              state: order?.address?.state || "",
              country: "India",
              postal_code: order?.address?.postalCode || "",
            },
            items:
              orderItems?.map((item) => ({
                medicineId: item?.medicineId,
                product_name: item?.medicineName || "",
                unit_price: item?.price || 0,
                quantity: item?.quantity || 0,
                total: ((item?.price || 0) * (item?.quantity || 0)).toFixed(2),
              })) || [],
          });
        } else {
          toast.error(res?.data?.message || "Failed to load order");
        }
      })
      .catch((err) => {
        console.error("Order details error", err);
        toast.error("Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (isLoading) {
    return (
      <Content>
        <div className="text-center mt-5">
          <Spinner color="primary" />
        </div>
      </Content>
    );
  }

  const toggleCancelOrder = (item) => {
    setSelectedRow(item);
    setShowModal(true);
  };

  const handleCancelOrder = (reason) => {
    if (!selectedRow) return;
    const payload = {
      orderId: orders?.id,
      remark: reason,
      mobile: selectedRow?.address?.mobile,
    };

    cancelOrderApi(payload)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          setShowModal(false);
          navigate(-1);
        } else if (res.data.status === false) {
          toast.error(res.data.message);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  if (!data) return null;

  return (
    <>
      <Head title="Order Details & Pharmacies" />
      <Content>
        {/* Header Section */}
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>{/* Empty for now */}</BlockHeadContent>
            <BlockHeadContent>
              <div className="d-flex gap-2">
                {/* {data?.order_status === "processing" && (
                  <Button color="danger" outline onClick={() => toggleCancelOrder(data)}>
                    <Icon name="cross" />
                    <span className="ms-1">Cancel Order</span>
                  </Button>
                )} */}
                <Button className={"p-3"} color="primary" outline onClick={() => navigate(-1)}>
                  <Icon name="arrow-left" />
                  {/* <span className="ms-1">Back</span> */}
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        {/* Two Column Layout */}
        <Row className="g-gs">
          {/* Left Column - Order Details */}
          <Col lg="5">
            <Card className="card-bordered h-100">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Order Items</h5>
                  <Badge color={getStatusColor(data.order_status)} pill>
                    {data.order_status}
                  </Badge>
                </div>

                <div className="mb-3 pb-2 border-bottom">
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Order :</span>
                    <span className="fw-bold">{data.order_no}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Date:</span>
                    <span>{data.date}</span>
                  </div>
                </div>

                {/* Items List */}
                <div className="mb-4" style={{ maxHeight: "250px", overflowY: "auto" }}>
                  <table className="table table-sm">
                    <thead className="table-light">
                      <tr>
                        <th>Item</th>
                        <th className="text-center">Qty</th>
                        <th className="text-end">Price</th>
                        <th className="text-end">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.items.map((item, idx) => (
                        <tr key={idx}>
                          <td>
                            <div className="fw-medium">{item.product_name}</div>
                          </td>
                          <td className="text-center">{item.quantity}</td>
                          <td className="text-end">
                            {RUPEES_SYMBOL}
                            {item.unit_price}
                          </td>
                          <td className="text-end">
                            {RUPEES_SYMBOL}
                            {item.total}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Order Summary */}
                <div className="bg-light p-3 rounded mb-3">
                  <div className="d-flex justify-content-between mb-1">
                    <span>Subtotal:</span>
                    <span>
                      {RUPEES_SYMBOL}
                      {Number(data?.subtotal || 0).toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <span>Discount:</span>
                    <span className="text-primary">
                      - {RUPEES_SYMBOL}
                      {data.discount}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between fw-bold pt-2 border-top">
                    <span>Grand Total:</span>
                    <span className="text-primary">
                      {RUPEES_SYMBOL}
                      {data.total_amount}
                    </span>
                  </div>
                </div>

                {/* Customer Info */}
                <div className="border rounded p-3">
                  <h6 className="mb-2">Customer Details</h6>
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <Icon name="user" size={16} />
                    <span>{data.address.full_name}</span>
                  </div>
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <Icon name="call" size={16} />
                    <span>{data.address.mobile}</span>
                  </div>
                  <div className="d-flex align-items-start gap-2">
                    <Icon name="map-pin" size={16} className="mt-1" />
                    <span>
                      {data.address.address}, {data.address.city}, {data.address.state} - {data.address.postal_code}
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3 mt-5">
                  {/* <h5 className="mb-0">Order Items</h5> */}

                  <Button className={"bg-primary text-light"}>Cancel Order</Button>
                </div>
              </CardBody>

            </Card>
          </Col>

          {/* Right Column - Pharmacies */}
          <Col lg="7">
            <Card className="card-bordered">
              <CardBody>
                <h5 className="mb-3">Nearby Pharmacies</h5>

                {pharmacyLoading ? (
                  <div className="text-center py-4">
                    <Spinner color="primary" size="sm" />
                  </div>
                ) : pharmacyData.length === 0 ? (
                  <div className="text-center py-4 text-muted">No pharmacies found</div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover align-middle">
                      <thead className="table-light p-5">
                        <tr>
                          <th>Store</th>
                          <th>Contact</th>
                          <th>Distance</th>
                          <th>Pincode</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pharmacyData.map((row, index) => (
                          <tr key={index}>
                            <td>
                              <div className="d-flex align-items-center gap-2 py-4">
                                <div className="avatar avatar-sm rounded-circle ">
                                  <UserAvatarCell
                                    row={row}
                                    name={row?.store_name}
                                    handleImageOpenPreview={handleImageOpenPreview}
                                    image={`${BASE_URL_IMG}${row.store_image}`}
                                  />
                                </div>
                                <div>
                                  <div className="fw-semibold">{row?.store_name || "N/A"}</div>
                                  <small className="text-muted">{row?.email}</small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div>{row?.mobile || row?.contact_number}</div>
                            </td>
                            <td>
                              <Badge color="light">{row?.distance} Km</Badge>
                            </td>
                            <td>{row?.pincode}</td>
                            <td className="text-center">
                              <Button
                                color="primary"
                                size="xs"
                                onClick={() => handleGoDashboard(row)}
                                className="btn-icon p-1"
                              >
                                Assign
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* Pagination */}
                    {pharmacyData.length > 5 && (
                      <div className="d-flex justify-content-end mt-3">
                        <nav>
                          <ul className="pagination pagination-sm">
                            <li className="page-item disabled">
                              <span className="page-link">Previous</span>
                            </li>
                            <li className="page-item active">
                              <span className="page-link">1</span>
                            </li>
                            <li className="page-item">
                              <span className="page-link">2</span>
                            </li>
                            <li className="page-item">
                              <span className="page-link">3</span>
                            </li>
                            <li className="page-item">
                              <span className="page-link">Next</span>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    )}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Updated Modal with Medicine Selection */}
        <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="lg" centered>
          <ModalHeader toggle={() => setViewModal(false)}>
            Assign Order to {selectedRow?.store_name || "Pharmacy"}
          </ModalHeader>

          <ModalBody>
            <div className="mb-4">
              <h6 className="mb-3">Select Medicines to Assign:</h6>

              {/* Select All Option */}
              <FormGroup check className="mb-3 pb-2 border-bottom">
                <Label check>
                  <Input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />{' '}
                  <strong>Select All Medicines</strong>
                </Label>
              </FormGroup>

              {/* Medicine List with Checkboxes */}
              <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                {medicineItems.map((item) => (
                  <FormGroup check key={item.id} className="mb-2">
                    <Label check className="d-flex align-items-center">
                      <Input
                        type="checkbox"
                        checked={item.selected}
                        onChange={() => handleMedicineSelect(item.id)}
                      />{' '}
                      <div className="ms-2">
                        <div className="fw-medium">{item.name}</div>
                        <small className="text-muted">
                          Qty: {item.quantity} | Price: {RUPEES_SYMBOL}{item.price} | Total: {RUPEES_SYMBOL}{item.total}
                        </small>
                      </div>
                    </Label>
                  </FormGroup>
                ))}
              </div>

              {/* Selected Summary */}
              {selectedMedicines.length > 0 && (
                <div className="mt-3 p-2 bg-light rounded">
                  <small>
                    <strong>{selectedMedicines.length}</strong> medicine(s) selected
                  </small>
                </div>
              )}
            </div>

            <div className="border-top pt-3">
              <p className="mb-1"><strong>Pharmacy:</strong> {selectedRow?.store_name}</p>
              <p className="mb-0"><strong>Contact:</strong> {selectedRow?.mobile || selectedRow?.contact_number}</p>
            </div>
          </ModalBody>

          <ModalFooter>
            <Button color="secondary" onClick={() => setViewModal(false)}>
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={handleConfirmClick}
              disabled={selectedMedicines.length === 0}
            >
              Confirm Assignment ({selectedMedicines.length} items)
            </Button>
          </ModalFooter>
        </Modal>
      </Content>

      {/* Cancel Order Modal */}
      <CancelOrderModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={handleCancelOrder}
        item={selectedRow}
      />
    </>
  );
};

export default PharmacyTelecallerOrderDetailsAndPharmac;  